/**
 * Valores iniciais do formulário de Member.
 */
export const initialMemberValues = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    document: "", // CPF
    birthDate: null,
    gender: "",
    maritalStatus: "single",
    photoUrl: null,

    // Endereço
    zipCode: "",
    address: "",
    number: "",
    complement: "",
    neighborhood: "",
    city: "",
    state: "",
    country: "Brasil",

    // Emergência
    emergencyContact: {
        name: "",
        phone: "",
        email: "",
        relationship: ""
    },

    // Saúde
    healthInfo: {
        bloodType: "",
        allergies: "",
        medications: "",
        medicalConditions: "",
        observations: ""
    },

    status: "lead",
    xpTotal: 0,
    consultant: null,
    teacher: null,
};
